import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sso/components';

import { instrumented } from './index';

const InstrumentedButton = ({ target, ...props }) => {
  const combined_props = { target, ...props };
  return <Button {...combined_props} />;
};

InstrumentedButton.propTypes = {
  target: PropTypes.string,
};

InstrumentedButton.defaultProps = {
  target: '_parent',
};

export default instrumented(InstrumentedButton, ['onClick'], {}, { doNotPassTrafficName: true });
